/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import Modal from 'react-modal';
import ActionButton from '../../common/ActionButton';
import RefreshButton from '../../common/refreshbutton';
import SearchBar from '../common/SearchBar';
import CollapsibleTable from '../bookings/CollapsibleTable';
import SendSMSContainer from '../freelancers/send_sms';
import SendNotificationContainer from '../freelancers/SendNotification';
import { withPushFiltersToUrl } from '../common/decorators';
import { BulkActions } from '../freelancers/BulkActions';
import history from '../../../history';
import { TFreelancerData, TMeta, TPageNotification, TUser } from '../../../types';
import BooleanDropdown from '../common/BooleanDropdown';
import { ClaimFreelancersContainer } from './ClaimFreelancers';
import { SelectRole } from '../../common/SelectRole';
import { ArchiveFreelancersPrompt } from './ArchiveFreelancers';
import FreelancerDetailsAgentNotes from '../../freelancer-details/freelancerDetailsAgentNotes';
import { executeHttpRequest } from '../../../epics/api';


type TUnallocatedFreelancersTableProps = {
    data: TFreelancerData[];
    meta: TMeta;
    pages: number;
    showPaginationBottom: boolean;
    loading: boolean;
    notification: TPageNotification;
    user: TUser;
    selectedUnallocatedFreelancers: TFreelancerData[];
    reloadData: () => void;
    setSelectedUnallocatedFreelancers: (allSelectedFreelancers: TFreelancerData[]) => void;
    currentPage?: number;
    onPageChange?: () => void;
    onSortedChange?: () => void;
    onFilterChange?: (filterKey?: string, filterValue?: { value: string }) => void;
    currentUrlParams: URLSearchParams;
};

type TUnallocatedFreelancersTableState = {
    isBulkMode: boolean;
    isBulkExclusiveMode: boolean;
    showSMS: boolean;
    showNotification: boolean;
    showClaimFreelancers: boolean;
    showArchiveFreelancers: boolean;
    lastCheckedRowIndex: number;
    lastCheckedRowArrayIndex: number;
};

type TTableRow = {
    original: TFreelancerData;
    value: string;
    isExpanded: boolean;
};

// @ts-ignore
@withPushFiltersToUrl
export default class UnallocatedWorkersTable extends Component<
    TUnallocatedFreelancersTableProps,
    TUnallocatedFreelancersTableState
> {
    state: TUnallocatedFreelancersTableState = {
        isBulkMode: false,
        isBulkExclusiveMode: false,
        showSMS: false,
        showNotification: false,
        showClaimFreelancers: false,
        showArchiveFreelancers: false,
        lastCheckedRowIndex: null,
        lastCheckedRowArrayIndex: null,
    };

    canExpandRow = () => true;

    onRowCheckboxChange = (rowInfo: TTableRow, checked: boolean, shiftKeyPressed: boolean) => {
        const { lastCheckedRowIndex, lastCheckedRowArrayIndex, isBulkExclusiveMode } = this.state;

        const rowIndex = rowInfo.original.id;
        const rowArrayIndex = this.props.data.findIndex(
            (object: { id: number; }) => object.id === rowIndex
        );
        let allSelectedFreelancers;

        if (shiftKeyPressed && this.props.selectedUnallocatedFreelancers.length > 0) {
            // handle selection with 'shift' key
            const start = Math.min(lastCheckedRowArrayIndex, rowArrayIndex);
            const end = Math.max(lastCheckedRowArrayIndex, rowArrayIndex);

            const rowSelectedFreelancers = this.props.data.filter(
                (_: never, index: number) => index >= start && index <= end
            );

            if (this.props.selectedUnallocatedFreelancers.some(
                freelancer => freelancer.id === lastCheckedRowIndex)
            ) {
                allSelectedFreelancers = new Set([
                    ...this.props.selectedUnallocatedFreelancers,
                    ...rowSelectedFreelancers
                ]);
            } else {
                allSelectedFreelancers = this.props.selectedUnallocatedFreelancers.filter(
                    freelancer => !rowSelectedFreelancers.some(
                        selected => selected.id === freelancer.id
                    )
                );
            }

            allSelectedFreelancers = Array.from(allSelectedFreelancers);

        } else if ((!isBulkExclusiveMode && checked) || (isBulkExclusiveMode && !checked)) {
                allSelectedFreelancers = this.props.selectedUnallocatedFreelancers.concat(
                    rowInfo.original,
                );
            } else {
                allSelectedFreelancers = this.props.selectedUnallocatedFreelancers.filter(
                    item => item.id !== rowInfo.original.id,
                );
            }

        this.setState({
            lastCheckedRowIndex: rowIndex,
            lastCheckedRowArrayIndex: rowArrayIndex,
        });
        this.props.setSelectedUnallocatedFreelancers(allSelectedFreelancers);
    };

    onToggleBulkMode = () => {
        this.setState(prevState => ({
            isBulkMode: !prevState.isBulkMode,
            isBulkExclusiveMode: false,
        }));
        this.props.setSelectedUnallocatedFreelancers([]);
    };

    onBulkAction = (key: string, val: { value: string }) => {
        if (val.value === 'send_sms') {
            this.setState({
                showSMS: true,
            });
        }
        if (val.value === 'send_notification') {
            this.setState({
                showNotification: true,
            });
        }
        if (val.value === 'claim_workers') {
            this.setState({
                showClaimFreelancers: true,
            });
        }
    };

    selectAllRows = () => {
        let allSelectedFreelancers;
        const allFreelancers = this.props.data;
        allSelectedFreelancers = new Set([
            ...this.props.selectedUnallocatedFreelancers,
            ...allFreelancers
        ]);
        allSelectedFreelancers = Array.from(allSelectedFreelancers);
        this.props.setSelectedUnallocatedFreelancers(allSelectedFreelancers);
    }

    deselectAllRows = () => {
        this.props.setSelectedUnallocatedFreelancers([]);
    }

    isRowChecked = (rowInfo: TTableRow) => {
        const { isBulkExclusiveMode } = this.state;
        const isInSelectedFreelancers = this.props.selectedUnallocatedFreelancers.some(
            item => item.id === rowInfo.original.id,
        );
        return isBulkExclusiveMode
            ? !isInSelectedFreelancers
            : isInSelectedFreelancers;
    };

    onActionSuccess = (withReload = false) => {
        this.setState({
            isBulkMode: false,
            isBulkExclusiveMode: false,
        });
        this.props.setSelectedUnallocatedFreelancers([]);
        if (withReload) {
            this.props.reloadData();
        }
    };

    updateFreelancerData = (id: number) => (fields: any) => (
        executeHttpRequest(`unallocated-freelancers/${id}/`, 'PATCH', fields)
    ).then(response => {
        this.props.reloadData();
        return response;
    }).catch(error => {
        this.props.notification.error(
            'Error',
            'Failed to update worker\'s notes',
        );
        return error;
    })

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);

        return (
            <div className="table-container">
                <div className="table-filter-container">
                    <SelectRole
                        onFilterChange={this.props.onFilterChange}
                        currentUrlParams={currentUrlParams}
                    />
                    <BooleanDropdown
                        onFilterChange={this.props.onFilterChange}
                        currentUrlParams={currentUrlParams}
                        filterKey="is_archived"
                        falseLabel="Live"
                        trueLabel="Archived"
                    />
                    <SearchBar
                        filterKey="search"
                        onFilterChange={this.props.onFilterChange}
                        currentUrlParams={currentUrlParams}
                    />
                    <div className="table-action-bar">
                        <BulkActions
                            isBulkExclusiveMode={this.state.isBulkExclusiveMode}
                            isBulkMode={this.state.isBulkMode}
                            items={this.props.selectedUnallocatedFreelancers}
                            totalNumberOfItemsInTable={
                                this.props.meta && this.props.meta.count
                            }
                            onBulkAction={this.onBulkAction}
                            user={this.props.user}
                            selectedJobs={[]}
                            isUnallocatedFreelancersRoute={true}
                            selectAllRows={this.selectAllRows}
                            deselectAllRows={this.deselectAllRows}
                        />
                        <RefreshButton reloadData={this.props.reloadData} />
                    </div>
                </div>
                <Modal
                    className="none"
                    contentLabel="SMS Modal"
                    isOpen={this.state.showSMS}
                >
                    <SendSMSContainer
                        freelancers={this.props.selectedUnallocatedFreelancers}
                        exclusive={this.state.isBulkExclusiveMode}
                        totalNumberOfItemsInTable={
                            this.props.meta && this.props.meta.count
                        }
                        notification={this.props.notification}
                        onActionSuccess={this.onActionSuccess}
                        closeModal={() => this.setState({ showSMS: false })}
                        isUnallocatedFreelancersRoute={true}
                    />
                </Modal>
                <Modal
                    className="none"
                    contentLabel="Notification Modal"
                    isOpen={this.state.showNotification}
                >
                    <SendNotificationContainer
                        freelancers={this.props.selectedUnallocatedFreelancers}
                        notification={this.props.notification}
                        onActionSuccess={this.onActionSuccess}
                        closeModal={() => this.setState({ showNotification: false })}
                        isUnallocatedFreelancersRoute={true}
                    />
                </Modal>
                <Modal
                    className="none"
                    contentLabel="Claim Worker Modal"
                    isOpen={this.state.showClaimFreelancers}
                    onRequestClose={() => this.setState({ showClaimFreelancers: false })}
                    ariaHideApp={false}
                >
                    <ClaimFreelancersContainer
                        freelancers={this.props.selectedUnallocatedFreelancers}
                        onActionSuccess={() => this.onActionSuccess(true)}
                        closeModal={() => this.setState({ showClaimFreelancers: false })}
                    />
                </Modal>
                <Modal
                    className="none"
                    contentLabel="Archive Worker Modal"
                    isOpen={this.state.showArchiveFreelancers}
                    onRequestClose={() => this.setState({ showArchiveFreelancers: false })}
                    ariaHideApp={false}
                >
                    <ArchiveFreelancersPrompt
                        freelancer={this.props.selectedUnallocatedFreelancers[0]}
                        onActionSuccess={() => this.onActionSuccess(true)}
                        closeModal={() => this.setState({ showArchiveFreelancers: false })}
                        notification={this.props.notification}
                    />
                </Modal>
                <CollapsibleTable
                    page={this.props.currentPage}
                    pageSize={0}
                    data={this.props.data}
                    pages={this.props.pages}
                    columns={this.tableColumns}
                    className="table-content"
                    loading={this.props.loading}
                    showPaginationBottom={this.props.showPaginationBottom}
                    showPageSizeOptions={false}
                    manual={true}
                    // eslint-disable-next-line no-return-assign, no-sequences
                    ref={table => (
                        // @ts-ignore
                        // eslint-disable-next-line no-sequences
                        (this.table = table), this.props.setTable(table)
                    )}
                    onPageChange={this.props.onPageChange}
                    onSortedChange={this.props.onSortedChange}
                    onRowCheckboxChange={this.onRowCheckboxChange}
                    onToggleBulkMode={this.onToggleBulkMode}
                    isBulkMode={this.state.isBulkMode}
                    isRowChecked={this.isRowChecked}
                    canExpandRow={this.canExpandRow}
                    expandUsingURLPrimaryKey={false}
                    SubComponent={(row: TTableRow) => (
                        <div className="expanded-content expanded-content-with-agent-notes">
                            {(
                                this.props.user.agency.features.includes('dashboard_sms') &&
                                this.props.user.permissions.includes('auth.sms_dashboard_allowed')
                            ) && (
                                <>
                                    <ActionButton
                                        text="Send notification..."
                                        onAction={() => {
                                            this.setState({
                                                isBulkMode: false,
                                                isBulkExclusiveMode: false,
                                                showNotification: true,
                                            });

                                            this.props.setSelectedUnallocatedFreelancers([
                                                // @ts-ignore
                                                row.original,
                                            ]);
                                        }}
                                        requiredFeature="dashboard_sms"
                                        requiredPermission="auth.sms_dashboard_allowed"
                                    />
                                    <ActionButton
                                        text="Send SMS..."
                                        onAction={() => {
                                            this.setState({
                                                isBulkMode: false,
                                                isBulkExclusiveMode: false,
                                                showSMS: true,
                                            });

                                            this.props.setSelectedUnallocatedFreelancers([
                                                // @ts-ignore
                                                row.original,
                                            ]);
                                        }}
                                        requiredFeature="dashboard_sms"
                                        requiredPermission="auth.sms_dashboard_allowed"
                                    />
                                </>
                            )}
                            {this.props.user.isAgent &&
                                <>
                                    <ActionButton
                                        text="Claim worker..."
                                        onAction={() => {
                                            this.setState({
                                                isBulkMode: false,
                                                isBulkExclusiveMode: false,
                                                showClaimFreelancers: true,
                                            });

                                            this.props.setSelectedUnallocatedFreelancers([
                                                // @ts-ignore
                                                row.original,
                                            ]);
                                        }}
                                    />
                                    {!row.original.is_archived &&
                                        <ActionButton
                                            text="Archive..."
                                            onAction={() => {
                                                this.setState({
                                                    isBulkMode: false,
                                                    isBulkExclusiveMode: false,
                                                    showArchiveFreelancers: true,
                                                });

                                                this.props.setSelectedUnallocatedFreelancers([
                                                    // @ts-ignore
                                                    row.original,
                                                ]);
                                            }}
                                        />
                                    }
                                </>
                            }
                        </div>
                    )}
                />
            </div>
        );
    }

    tableColumns = [
        {
            Header: 'Ref',
            accessor: 'reference_number',
            headerClassName: 'small-col',
            className: 'small-col',
            Cell: (row: TTableRow) => (
                <span title={row.value}>{row.value} </span>
            ),
        },
        {
            Header: 'Photo',
            accessor: 'freelancer_detail.photo_thumbnail_medium',
            sortable: false,
            headerClassName: 'xsmall-col',
            className: 'xsmall-col',
            Cell: (row: TTableRow) => {
                const freelancerImg = row.original.photo_thumbnail_large
                    ? row.original.photo_thumbnail_large
                    : '/static/images/default_profile.png';
                return (
                    <div>
                        <a
                            className="group-link"
                            href={freelancerImg}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <div
                                className="avatar"
                                style={{
                                    backgroundImage: `url(${freelancerImg})`,
                                }}
                            />
                        </a>
                    </div>
                );
            },
        },
        {
            Header: 'Name',
            accessor: 'full_name',
            Cell: (row: TTableRow) => (
                <span title={row.value}>{row.value} </span>
            ),
        },
        {
            Header: 'Service',
            accessor: 'service_key',
            headerClassName: 'small-col',
            className: 'small-col upper-case',
        },
        {
            Header: 'Role(s)',
            accessor: 'service_role',
            headerClassName: 'small-col',
            className: 'small-col upper-case',
            Cell: (row: TTableRow) => (
                <span title={row.value}>{row.value} </span>
            ),
        },
        {
            Header: 'Mobile',
            accessor: 'mobile',
            headerClassName: 'small-col',
            className: 'small-col',
            sortable: false,
            show: this.props.user.isAgent,
            Cell: (row: TTableRow) => {
                const mobileLink = `tel:${row.value}`;
                return (
                    <a
                        className="group-link"
                        href={mobileLink}
                        title={row.value}
                    >
                        {row.value && row.value.length === 11
                            ? `${row.value.substr(0, 5)} ${row.value.substr(
                                  5,
                                  11,
                              )}`
                            : row.value}
                    </a>
                );
            },
        },
        {
            Header: 'Email',
            accessor: 'email',
            sortable: false,
            show: this.props.user.isAgent,
            Cell: (row: TTableRow) => {
                const mailToAddress = `mailto:${row.value}`;
                return (
                    <a
                        className="group-link"
                        href={mailToAddress}
                        title={row.value}
                    >
                        {row.value}
                    </a>
                );
            },
        },
        {
            Header: 'Post Code',
            accessor: 'postcode',
            headerClassName: 'small-col',
            className: 'small-col upper-case',
            Cell: (row: TTableRow) => (
                <span title={row.value}>{row.value} </span>
            ),
        },
        {
            // used with 'expanded-content-with-agent-notes' css class for action buttons styling
            Header: 'Notes',
            accessor: 'agent_notes',
            sortable: false,
            show: this.props.user.isAgent,
            Cell: (row: TTableRow) =>
                row.isExpanded
                    ? <FreelancerDetailsAgentNotes
                            agentNotes={row.value}
                            onSave={this.updateFreelancerData(row.original.id)}
                            isTable={true}
                    />
                    : row.value
        },
    ];
}
